<template>
  <div>
    <div class="header-top">
      <div class="header-box center">
        <div class="header-box-left logo">
          <!-- <h1 class="header_h1_name">易知鸟</h1> -->
        </div>
        <div class="header-box-right">
          <ul class="nav-top">
            <li
              class="nav-tab"
              :class="[
                { active: fromId == index },
                { dropdown: index == 1 || index == 5 }
              ]"
              v-for="(x, index) in navs"
              @mouseenter="showDrop(x, index, $event)"
              @mouseleave="isShow = false"
            >
              <!-- @mouseleave="isShow = false"  v-if="index != 5"-->
              <span @click="gotoPage(x.link, index)">{{ x.name }}</span>
              <!-- <span v-if="index == 5"><a  href="https://www.yizhiniao.com/mall/#/login"  target="_blank">{{x.name}}</a></span> -->
              <ul
                class="nav-drop"
                v-if="index == 1 && isShow"
                :style="dropStyle"
              >
                <li
                  v-if="showIndex == 1"
                  v-for="(y, index_) in drop1"
                  @click="gotoPage(y.link, index_, y.parent)"
                  :class="{ active: parentId == y.parent + '_' + index_ }"
                >
                  <div class="image">
                    <img :src="y.image" alt="" width="100%" />
                  </div>
                  <div class="name">{{ y.name }}</div>
                </li>
              </ul>
              <!-- <ul class="nav-drop" v-if="index==6 && isShow" :style="dropStyle" >
                                <li v-if="showIndex==6"  v-for="(y,index_) in drop2"  @click="gotoPage(y.link,index_,y.parent)" :class="{'active':parentId == (y.parent+'_'+index_)}">{{y.name}}</li>
                            </ul> -->
            </li>
          </ul>
          <div class="login-box">
            <div class="btn">
              <a href="https://www.yizhiniao.com?website=1" target="_blank"
                >机构登录</a
              >
            </div>
            <div class="btn bgRed" @click="openDialog('免费试用', 0)">
              申请试用
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fromId: 0,
      parentId: undefined,
      // showDrop:false,
      isShow: false,
      showIndex: undefined,
      dropStyle: {},
      droplist: [],
      navs: [
        { name: "首页", link: "/home" },
        { name: "产品", link: "/product_jiaopei" },
        { name: "合作客户", link: "/customer" },
        { name: "服务支持", link: "/service" },
        { name: "产业学院", link: "/school" },
        // { name: "易知家商城", link: "/shopMall" },
        { name: "招商加盟", link: "/joinUs" },
        { name: "关于我们", link: "/aboutUs_intro" }
      ],
      drop1: [
        {
          name: "教培管理系统",
          link: "/product_jiaopei",
          parent: "1",
          image: "/static/img/common/product_01.png"
        },
        {
          name: "招生营销工具",
          link: "/product_zhaosheng",
          parent: "1",
          image: "/static/img/common/product_02.png"
        },
        {
          name: "便捷支付方式",
          link: "/product_pay",
          parent: "1",
          image: "/static/img/common/product_03.png"
        },
        {
          name: "家校服务平台",
          link: "/product_hservice",
          parent: "1",
          image: "/static/img/common/product_04.png"
        },
        {
          name: "刷脸签到点名",
          link: "/product_face",
          parent: "1",
          image: "/static/img/common/product_05.png"
        },
        {
          name: "线上课程教学",
          link: "/product_online",
          parent: "1",
          image: "/static/img/common/product_06.png"
        },
        {
          name: "打卡作业督学",
          link: "/product_onwork",
          parent: "1",
          image: "/static/img/common/product_07.png"
        }
      ],
      drop2: [
        // { name: "行业新闻", link: '/aboutUs_news' ,parent:"6"},
        { name: "企业介绍", link: "/aboutUs_intro", parent: "7" }
      ]
    };
  },
  created() {
    let route_ = this.$route;
    if (route_.name == "home") {
      this.fromId = 0;
    } else {
      let query = JSON.parse(localStorage.getItem("current"));
      if (query && query.parentId) {
        this.fromId = query.fromId;
        this.parentId = query.parentId;
      } else {
        this.fromId = query.fromId;
        this.parentId = undefined;
      }
    }
    //加上后每次刷新页面滚动到页面顶部

    // window.addEventListener("beforeunload", () => {
    //     window.scrollTo(0,0);
    // })
  },
  mounted() {},
  watch: {
    $route(data) {
      console.log(data);
      if (data.query && data.query.parentId) {
        this.fromId = data.query.fromId;
        this.parentId = data.query.parentId;
      } else {
        this.fromId = data.query.fromId;
        this.parentId = undefined;
      }
    }
  },
  methods: {
    gotoPage(page, ind, parent_) {
      if (parent_) {
        this.$router.push({
          path: page,
          query: {
            fromId: "" + parent_,
            parentId: parent_ ? parent_ + "_" + ind : undefined
          }
        });
      } else {
        this.$router.push({
          path: page,
          query: {
            fromId: "" + ind
          }
        });
      }
      var query = this.$route.query;
      localStorage.setItem("current", JSON.stringify(query));
    },
    showDrop(x, ind, e) {
      var offset = e.target.getBoundingClientRect(),
        width = offset.width,
        left_ = -110 + width / 2;
      this.isShow = true;
      this.showIndex = ind;
      console.log(this.showIndex);
      // if (x.name == "产品") {
      //     this.droplist = this.drop1;
      // } else if (x.name == "关于我们") {
      //     this.droplist = this.drop2;
      // } else {
      //     this.droplist = [];
      // }
      this.dropStyle = { left: left_ + "px" };
    },
    openDialog: function(title, type) {
      //type:(0机构,1微官网)
      this.$parent.$refs.openPop.openDialog(title, type);
    }
  }
};
</script>

<style scoped lang="less">
.header-top {
  position: fixed;
  top: 0;
  font-size: 16px;
  width: 100%;
  height: 80px;
  line-height: 80px;
  background: #ffffff;
  z-index: 100000;

  .header-box {
    padding: 0 24px;
    height: 80px;
    line-height: 80px;
    overflow: visible;
  }

  .header-box .header-box-left {
    width: 110px;
    margin-top: 21px;
    height: 37px;
    float: left;
    background: url(/static/img/common/head-logo.png) no-repeat center;
    background-size: 100%;
  }

  .header-box .header-box-right {
    float: right;

    .nav-top {
      float: left;
      > li {
        float: left;
        position: relative;
        cursor: pointer;
        margin-right: 30px;
        line-height: 80px;
        > span {
          width: 100%;
          height: 100%;
          line-height: 100%;
          display: inline-block;
          padding: 5px 4px;
          color: #4a4a4a;
          > a {
            display: inline-block;
            color: #4a4a4a;
          }
          &:after {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 1px;
            content: "";
          }
        }
        &:hover,
        &.active {
          > span {
            color: #fa7074;
            border-bottom: 2px solid #fa7074;
            > a {
              display: inline-block;
              color: #fa7074;
            }
          }
        }
      }
      li.dropdown {
        .nav-drop {
          position: absolute;
          background: #fff;
          z-index: 2;
          top: 79px;
          width: 220px;
          /* padding:30px 0; */

          /* box-shadow: 0px 2px 30px 0px rgba(191, 202, 214, 0.5); */
          > li {
            width: 100%;
            padding: 0px 30px;
            height: 40px;
            line-height: 40px;
            cursor: pointer;
            margin-bottom: 15px;
            .image {
              float: left;
              display: inline-block;
              width: 40px;
              height: 40px;
              margin-right: 20px;
            }
            .name {
              float: left;
              display: inline-block;
            }
            &:first-child {
              margin-top: 20px;
            }
            &:last-child {
              margin-bottom: 0px;
              margin-bottom: 20px;
            }
            &:hover,
            &.active {
              color: #fa7074;
            }
          }
        }
      }
    }

    .login-box {
      width: 210px;
      margin-top: 21px;
      display: flex;
      justify-content: space-between;
    }

    .login-box .btn {
      width: 100px;
      height: 34px;
      line-height: 30px;
      &.bgRed {
        line-height: 34px;
      }
      &:hover,
      &:active {
        line-height: 34px;
      }
      a {
        color: #fa7074;
      }
    }
  }
}
.header_h1_name {
  position: absolute;
  left: -1000px;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue